import { render, staticRenderFns } from "./designationStatus.vue?vue&type=template&id=0b61018d&"
import script from "./designationStatus.vue?vue&type=script&lang=js&"
export * from "./designationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports